import Api from 'api';

import {
  GET_CUSTOM_FIELDS_EMPLOYEES,
  SET_CUSTOM_FIELDS_EMPLOYEES_PAGINATION,
  SET_CUSTOM_FIELDS_EMPLOYEES_FILTERS,
  RESET_CUSTOM_FIELDS_EMPLOYEES,
  TOGGLE_CUSTOM_FIELDS_EMPLOYEE,
  ADD_CUSTOM_FIELDS_EMPLOYEE,
  UPDATE_CUSTOM_FIELDS_EMPLOYEE,
  GET_CUSTOM_FIELDS_EMPLOYEE_BY_ID,
  RESET_CUSTOM_FIELDS_EMPLOYEE_FORM,
  MODIFY_EDITING_CUSTOM_FIELDS_EMPLOYEE,
  ADD_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE,
  REMOVE_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE,
} from '../constants';

export const setPagination = (payload) => ({
  type: SET_CUSTOM_FIELDS_EMPLOYEES_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_CUSTOM_FIELDS_EMPLOYEES_FILTERS,
  payload,
});

export const getCustomFieldsEmployees = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_CUSTOM_FIELDS_EMPLOYEES,
  payload: Api.custom_fields_employees.get(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ), // En desarrollo
});

export const reset = () => ({ type: RESET_CUSTOM_FIELDS_EMPLOYEES });

export const toggle = (customFieldsEmployeeId, companyId, subcompanyId) => ({
  type: TOGGLE_CUSTOM_FIELDS_EMPLOYEE,
  meta: { id: customFieldsEmployeeId },
  payload: Api.custom_fields_employees.toggle(customFieldsEmployeeId, companyId, subcompanyId), // Falta
});

export const resetForm = () => ({ type: RESET_CUSTOM_FIELDS_EMPLOYEE_FORM });

export const getCustomFieldEmployeeById = (customFieldsEmployeeId, companyId, subcompanyId) => ({
  type: GET_CUSTOM_FIELDS_EMPLOYEE_BY_ID,
  meta: { needAuth: true },
  payload: Api.custom_fields_employees.getById(customFieldsEmployeeId, companyId, subcompanyId), // Falta
});

export const modifyCustomFieldEmployee = (payload) => ({
  type: MODIFY_EDITING_CUSTOM_FIELDS_EMPLOYEE,
  payload,
});

export const addCustomFieldEmployee = (companyId, subcompanyId, customFieldEmployee) => ({
  type: ADD_CUSTOM_FIELDS_EMPLOYEE,
  payload: Api.custom_fields_employees.add(companyId, subcompanyId, customFieldEmployee), // Falta
});

export const updateCustomFieldEmployee = (
  customFieldEmployeeId,
  companyId,
  subcompanyId,
  customFieldEmployee
) => ({
  type: UPDATE_CUSTOM_FIELDS_EMPLOYEE,
  meta: { id: customFieldEmployeeId, needAuth: true },
  payload: Api.custom_fields_employees.update(
    customFieldEmployeeId,
    companyId,
    subcompanyId,
    customFieldEmployee
  ), // Falta
});

export const addCustomField = () => ({ type: ADD_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE });

export const removeCustomField = (index) => ({
  type: REMOVE_CUSTOM_FIELD_CUSTOM_FIELDS_EMPLOYEE,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/actions/employees_actions.js